import React, { useEffect, useState } from 'react';

export const getThemeVariableValue = (variable) => {
  const cssVariables = window.__APP_THEME__?.variables?.css;
  const metaVariables = window.__APP_THEME__?.variables?.meta;
  const value = cssVariables?.[variable] ?? metaVariables?.[variable];
  if (value) {
    return value;
  }
  return null;
};

export const getAppName = () =>
  getThemeVariableValue('app-name') || 'Liquid Noble';

const initPageTitle = () => {
  const appName = getAppName();
  const pageTitle = document.querySelector('title');
  if (pageTitle) {
    pageTitle.innerText = appName;
  }
};

const ThemeLoader = ({ children }) => {
  const [themeLoaded, setThemeLoaded] = useState(false);

  useEffect(() => {
    let interval;

    const checkTheme = () => {
      if (
        window.__APP_THEME__ &&
        Object.keys(window.__APP_THEME__).length > 0
      ) {
        setThemeLoaded(true);
        clearInterval(interval);

        console.log('Theme loaded:', window.__APP_THEME__);
        const cssVariables = window.__APP_THEME__.variables?.css ?? {};
        Object.entries(cssVariables).forEach(([key, value]) => {
          console.log(`Setting CSS variable --${key} to ${value}`);
          document.documentElement.style.setProperty(`--${key}`, value);
        });

        initPageTitle();
      }
    };

    checkTheme(); // In case it's already set

    if (!themeLoaded) {
      interval = setInterval(checkTheme, 200);
    }

    return () => clearInterval(interval);
  }, [themeLoaded]);

  if (!themeLoaded) {
    return (
      <div className="app-loader">
        <div className="circle-loader" />
      </div>
    );
  }

  return children;
};

export default ThemeLoader;
